import { Commit } from 'vuex';
import * as Types from './types';
import * as API from './api';
import { IFollowState } from './interface';
import { Toast } from 'vant';

const state: IFollowState = {
    loadingUserInfo: false,
    followUserInfo: {},
    followState: '待审核',
    followedUsers: {} as any,
    groupLoading: false,
    groupList: [],
    userLoading: false,
    userList: [],
    userMeLoading: false,
    userMeList: [],
    recommendLoading: false,
    recommendList: [],
    cancelResult: {} as any,
    freeFollow: 0,
};

const actions = {
    async [Types.GET_FOLLOWED_USER_INFO](context: { commit: Commit; state: IFollowState }, params: any) {
        let followUserInfo: any = {};
        context.commit(Types.GET_FOLLOWED_USER_INFO, { loading: true, followUserInfo });
        followUserInfo = await API.GetFollowedUserInfo(params);
        context.commit(Types.GET_FOLLOWED_USER_INFO, { loading: false, followUserInfo });
    },
    async [Types.AGREE_FOLLOWED](context: { commit: Commit; state: IFollowState }, params: any) {
        Toast.loading('');
        const result = await API.AgreeSomeoneFollowedMe(params);
        context.commit(Types.AGREE_FOLLOWED, result);
    },
    async [Types.REFUSE_FOLLOWED](context: { commit: Commit; state: IFollowState }, params: any) {
        Toast.loading('');
        const result = await API.RefuseSomeoneFollowedMe(params);
        context.commit(Types.REFUSE_FOLLOWED, result);
    },
    async [Types.GET_USER_LIST_FOLLOW](context: { commit: Commit; state: IFollowState }, params: any) {
        let userList: any = [];
        context.commit(Types.GET_USER_LIST_FOLLOW, { loading: true, userList });
        userList = await API.getUserListIFollowed(params);
        context.commit(Types.GET_USER_LIST_FOLLOW, { loading: false, userList });
    },
    async [Types.GET_USER_LIST_FOLLOW_ME](context: { commit: Commit; state: IFollowState }, params: any) {
        let userMeList: any = [];
        context.commit(Types.GET_USER_LIST_FOLLOW_ME, { loading: true, userMeList });
        userMeList = await API.getUserListIFollowedMe(params);
        context.commit(Types.GET_USER_LIST_FOLLOW_ME, { loading: false, userMeList });
    },
    async [Types.GET_RECOMMEND_FOLLOW](context: { commit: Commit; state: IFollowState }, params: any) {
        let recommendList: any = [];
        context.commit(Types.GET_RECOMMEND_FOLLOW, { loading: true, recommendList });
        recommendList = await API.getUserListRecommendToFollow(params);
        context.commit(Types.GET_RECOMMEND_FOLLOW, { loading: false, recommendList });
    },
    async [Types.GET_GROUP_FOLLOW](context: { commit: Commit; state: IFollowState }, params: any) {
        let groupList: any = [];
        context.commit(Types.GET_GROUP_FOLLOW, { loading: true, groupList });
        groupList = await API.getUserListInGroupToFollow(params);
        context.commit(Types.GET_GROUP_FOLLOW, { loading: false, groupList });
    },
    async [Types.CANCEL_SOMEONE_FOLLOWED](context: { commit: Commit; state: IFollowState }, params: any) {
        const result = await API.cancelSomeoneIFollowed(params);
        context.commit(Types.CANCEL_SOMEONE_FOLLOWED, result);
    },
    async [Types.FOLLOW_SOMEONE](context: { commit: Commit; state: IFollowState }, params: any) {
        await API.followedSomeone(params);
    },
    async [Types.CANCEL_SOMEONE_FOLLOW_ME](context: { commit: Commit; state: IFollowState }, params: any) {
        await API.cancelSomeoneFollowedMe(params);
    },
    async [Types.GET_USER_FOLLOW_SETTING](context: { commit: Commit; state: IFollowState }, params: any) {
        const result = await API.getUserFollowSetting(params);
        context.commit(Types.GET_USER_FOLLOW_SETTING, result);
    },
    async [Types.SET_USER_FOLLOW_SETTING](context: { commit: Commit; state: IFollowState }, params: any) {
        await API.setUserFollowSetting(params);
    },
};

const mutations = {
    [Types.GET_FOLLOWED_USER_INFO](state: IFollowState, payload: any) {
        state.loadingUserInfo = payload.loading;
        state.followUserInfo = payload.followUserInfo;
        state.followState = payload.followUserInfo.FollowState && payload.followUserInfo.FollowState !== '待审核' ? (payload.followUserInfo.FollowState === '已关注' ? payload.followUserInfo.FollowState : '已拒绝') : '待审核';
    },
    [Types.AGREE_FOLLOWED](state: IFollowState, payload: any) {
        if (payload.result) {
            state.followState = '已关注';
            Toast.success('同意成功');
        }
    },
    [Types.REFUSE_FOLLOWED](state: IFollowState, payload: any) {
        if (payload.result) {
            state.followState = '已拒绝';
            Toast.success('拒绝成功');
        }
    },
    [Types.GET_USER_LIST_FOLLOW](state: IFollowState, payload: any) {
        state.userLoading = payload.loading;
        state.userList = payload.userList;
    },
    [Types.GET_USER_LIST_FOLLOW_ME](state: IFollowState, payload: any) {
        state.userMeLoading = payload.loading;
        state.userMeList = payload.userMeList;
    },
    [Types.GET_GROUP_FOLLOW](state: IFollowState, payload: any) {
        state.groupLoading = payload.loading;
        state.groupList = payload.groupList;
    },
    [Types.GET_RECOMMEND_FOLLOW](state: IFollowState, payload: any) {
        state.recommendLoading = payload.loading;
        state.recommendList = payload.recommendList;
    },
    [Types.CANCEL_SOMEONE_FOLLOWED](state: IFollowState, payload: any) {
        state.cancelResult = payload;
    },
    [Types.GET_USER_FOLLOW_SETTING](state: IFollowState, payload: any) {
        state.freeFollow = payload.FreeFollow;
    },
};

export default { namespaced: true, state, actions, mutations };
